module.exports = __webpack_public_path__ + "static/baggage-682f463f03bc1e999a72eee4229e80cc.svg";